import { faCalculator } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Space, Tooltip } from 'antd'
import { useContext, useState } from 'react'
import { EnteredRateQuantities, getTemplateRatesButtonState, labelTemplateGroups, QuantityChange } from '../../../domain/productionRate'
import useFeatureFlag from '../../../hooks/useFeatureFlag'
import { useAllTemplatesQuery } from '../../Templates/templateQueries'
import { getTemplateRateChangeGroups, getTemplateRateGroups, ServerState } from '../itemModel'
import { ItemsContext } from '../ItemsRoot'
import TemplateProductionRatesModal from './TemplateProductionRatesModal'

type Props = {
  workareaId: number
  disabled?: boolean
}

const TemplateProductionRatesButton = ({ workareaId, disabled }: Props) => {
  const { changeSet, jobItemsQuery, dispatch } = useContext(ItemsContext)
  const isFeatureEnabled = useFeatureFlag('web-bulk-production-rates')
  const [open, setOpen] = useState(false)
  const templatesQuery = useAllTemplatesQuery(false, isFeatureEnabled && open)

  if (!isFeatureEnabled) {
    return <></>
  }

  const serverState: ServerState = {
    workareaItems: jobItemsQuery.data?.estimatedItems ?? [],
    catalogItems: jobItemsQuery.data?.catalogItems ?? [],
    templateItems: jobItemsQuery.data?.templateItems ?? [],
  }
  const templateNames = templatesQuery.data ?? []
  const unitGroups = labelTemplateGroups(getTemplateRateGroups(changeSet, serverState, workareaId), templateNames)

  const buttonState = getTemplateRatesButtonState(disabled === true, jobItemsQuery.isLoading, unitGroups.length)

  const getChangeGroups = (entered: EnteredRateQuantities) => {
    return labelTemplateGroups(getTemplateRateChangeGroups(changeSet, serverState, workareaId, entered), templateNames)
  }

  const handleApply = (changes: QuantityChange[]) => {
    dispatch({ type: 'BULK_PRODUCTION_RATES_APPLIED', changes, serverState })
  }

  return <>
    <Tooltip title={buttonState.reason}>
      <Button size="large" disabled={buttonState.isDisabled} onClick={() => setOpen(true)}>
        <Space><FontAwesomeIcon icon={faCalculator} />Template Production Rates</Space>
      </Button>
    </Tooltip>
    <TemplateProductionRatesModal
      open={open}
      unitGroups={unitGroups}
      isLoadingTemplateNames={templatesQuery.isLoading}
      getChangeGroups={getChangeGroups}
      onClose={() => setOpen(false)}
      onApply={handleApply}
    />
  </>
}

export default TemplateProductionRatesButton
